import {
	PEOPLE_TRAINING_ASSIGNMENT_STATUS,
	PEOPLE_TRAINING_PRACTICAL_OUTCOME_NAMES,
} from '../../../common/constants';

export const getEmployeeDisplayName = (employee) => {
	if (!employee) {
		return '';
	}

	return [employee.preferredName || employee.firstName, employee.lastName]
		.filter(Boolean)
		.join(' ');
};

export const getTrainingOutcomeLabel = (assignment) => {
	const outcomeName = PEOPLE_TRAINING_PRACTICAL_OUTCOME_NAMES[assignment?.latestResult?.practicalOutcome];
	if (outcomeName) {
		return outcomeName;
	}

	if (assignment?.assignmentStatus === PEOPLE_TRAINING_ASSIGNMENT_STATUS.COMPLETED_IN_PERSON) {
		return 'Completed in person';
	}

	return 'Completed';
};
